import React, { useEffect, useRef, useState } from "react";
import "./Employee.scss";
import CustomTextField from "../../TextFiled/Index";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  FormControl,
  IconButton,
  InputAdornment,
  MenuItem,
  Modal,
  Select,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { IoIosSearch, IoMdClose, IoMdCloseCircleOutline } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import Header from "../Home/Header/Header";
import { CommonAPImain } from "../../../Utils/API/CommonAPImain/CommonAPImain";
import { EmployeeActive } from "../../../Utils/API/EmployeeActive/EmployeeActive";
import { ResetPassword } from "../../../Utils/API/ResetPassword/ResetPassword";
import Snackbar from "../MetalPriceUpdate/snackbar/Snackbar";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CryptoJS from "crypto-js";
import { IoClose } from "react-icons/io5";

const Employee = () => {
  const [filteredData, setFilteredData] = useState();
  const [employeeFullData, setEmployeeFullData] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const [selectedUserIdNum, setSelectedUserIdNum] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [columnToUpdate, setColumnToUpdate] = useState(null);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [filterOption, setFilterOption] = useState("All");
  const [errors, setErrors] = useState({
    userId: "",
    currentPassword: "",
    confirmPassword: "",
  });
  const [passwordDetails, setPasswordDetails] = useState({
    userId: "",
    currentPassword: "",
    confirmPassword: "",
  });

  const [showPassword, setShowPassword] = useState({
    currentPassword: false,
    confirmPassword: false,
  });

  const navigate = useNavigate();

  const gridRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (gridRef.current) {
        gridRef.current.style.height = `${window.innerHeight - 190}px`;
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setIsLoading(true);
    CommonAPImain("EmployeeDetail")
      .then((response) => {
        if (response?.Data) {
          setFilteredData(response?.Data?.DT);
          setEmployeeFullData(response?.Data?.DT);
          setIsLoading(false);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const validate = () => {
    let isValid = true;
    let validationErrors = {
      userId: "",
      currentPassword: "",
      confirmPassword: "",
    };

    if (!passwordDetails.userId) {
      validationErrors.userId = "User ID is required";
      isValid = false;
    }

    if (!passwordDetails.currentPassword) {
      validationErrors.currentPassword = "Current Password is required";
      isValid = false;
    }

    if (!passwordDetails.confirmPassword) {
      validationErrors.confirmPassword = "Confirm Password is required";
      isValid = false;
    } else if (
      passwordDetails.confirmPassword !== passwordDetails.currentPassword
    ) {
      validationErrors.confirmPassword = "Passwords do not match";
      isValid = false;
    }

    setErrors(validationErrors);
    return isValid;
  };

  const handleFilter = (status) => {
    if (status === "All") {
      setFilteredData(employeeFullData);
    } else if (status === "Deactive") {
      const filtered = employeeFullData.filter(
        (employee) => employee["IsActive"] === 0
      );
      setFilteredData(filtered);
    } else {
      const filtered = employeeFullData.filter(
        (employee) => employee[status] === 1
      );
      setFilteredData(filtered);
    }
  };

  const handleFilterDeactive = (isActive) => {
    const filtered = employeeFullData.filter(
      (employee) => employee.IsActive == isActive
    );
    setFilteredData(filtered);
  };

  const clearFilter = () => {
    setFilteredData(employeeFullData);
  };

  const columns = [
    // {
    //   field: "UserID",
    //   headerName: "User ID",
    //   width: 100,
    //   renderCell: (params) => (
    //     <div
    //       style={{
    //         display: "flex",
    //         flexDirection: "column",
    //         justifyContent: "center",
    //         height: "100%",
    //       }}
    //     >
    //       <span
    //         style={{
    //           display: "flex",
    //           alignItems: "center",
    //         }}
    //       >
    //       </span>
    //     </div>
    //   ),
    // },
    {
      field: "userName",
      headerName: "User ID",
      width: 150,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            height: "100%",
          }}
        >
          {(params.row.firstname != null || params.row.lastname != null) && (
            <span
              style={{
                fontWeight: "bold",
                color: "#333",
                display: "flex",
                alignItems: "center",
                height: "16px",
                fontSize: "13px",
              }}
            >
              {params.row.firstname} {params.row.lastname}
            </span>
          )}
          <span
            style={{
              fontWeight: "bold",
              color: "rgb(165 156 156)",
              display: "flex",
              alignItems: "center",
              height: "20px",
              fontSize: "10px",
            }}
          >
            {params.row.UserID}
          </span>
          <span
            style={{
              fontSize: "12px",
              color: "#777",
              display: "flex",
              alignItems: "center",
              height: "12px",
              fontSize: "10px",
            }}
          >
            {params.row.customercode} - {params.row.designation}
          </span>
        </div>
      ),
    },
    {
      field: "IsActive",
      headerName: "Active",
      width: 70,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <div
            style={{
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              backgroundColor: params.value
                ? "rgb(40, 199, 111)"
                : "rgb(244, 67, 54)",
            }}
            onClick={() =>
              handleStatusChange(
                params.row.UserID,
                params.value,
                "IsActive",
                params.row.id
              )
            }
          ></div>
        </div>
      ),
    },
    {
      field: "IsLogin",
      headerName: "Login",
      width: 80,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <div
            style={{
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              backgroundColor: params.value
                ? "rgb(40, 199, 111)"
                : "rgb(244, 67, 54)",
            }}
            onClick={() =>
              handleStatusChange(
                params.row.UserID,
                params.value,
                "IsLogin",
                params.row.id
              )
            }
          ></div>
        </div>
      ),
    },
    {
      field: "IsRoaming",
      headerName: "Roaming",
      width: 90,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <div
            style={{
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              backgroundColor: params.value
                ? "rgb(40, 199, 111)"
                : "rgb(244, 67, 54)",
            }}
            onClick={() =>
              handleStatusChange(
                params.row.UserID,
                params.value,
                "IsRoaming",
                params.row.id
              )
            }
          ></div>
        </div>
      ),
    },
  ];

  const handleStatusChange = (userId, currentStatus, column, numID) => {
    setSelectedUserIdNum(numID);
    setSelectedUserId(userId);
    setColumnToUpdate(column);
    const action = currentStatus === 1 ? "Deactive" : "Active";
    const Login = column === "IsRoaming" ? "Roming" : "Login";
    const message =
      column == "IsActive"
        ? `Are you sure you want to ${action} ${userId}?`
        : `Are you sure you want to ${action} ${Login} on ${userId}?`;
    setConfirmationMessage(message);
    setOpenConfirmation(true);
  };

  const handleModalOpen = () => {
    setOpenModal(true);
  };

  const handleModalClose = () => {
    setOpenModal(false);
    setPasswordDetails({
      userId: "",
      currentPassword: "",
      confirmPassword: "",
    });
  };

  const handleInputChange = (field, value) => {
    setPasswordDetails((prevState) => ({
      ...prevState,
      [field]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [field]: "",
    }));
  };

  function hashPasswordSHA1(password) {
    const hashedPassword = CryptoJS.SHA1(password).toString(CryptoJS.enc.Hex);
    return hashedPassword;
  }

  const handleSave = () => {
    if (!validate()) return;
    setIsLoading(true);

    const hashedPassword = hashPasswordSHA1(passwordDetails?.confirmPassword);

    ResetPassword("ResetPassWord", passwordDetails?.userId, hashedPassword)
      .then((response) => {
        if (response?.Data) {
          setSnackbarOpen(true);
          setTimeout(() => {
            setSnackbarOpen(false);
          }, 3000);
          setIsLoading(false);
        }
      })
      .catch((err) => console.log(err));
    handleModalClose();
  };

  const handleConfirmChange = () => {
    if (selectedUserId && columnToUpdate) {
      const updatedData = filteredData.map((employee) => {
        if (employee.UserID === selectedUserId) {
          let mode = "";
          switch (columnToUpdate) {
            case "IsLogin":
              mode = "Employee_LoginFlag";
              break;
            case "IsActive":
              mode = "Employee_ActiveFlag";
              break;
            case "IsRoaming":
              mode = "Employee_RoamingFlag";
              break;
            default:
              break;
          }

          let modeActive = "";
          switch (columnToUpdate) {
            case "IsLogin":
              modeActive = "IsLogin";
              break;
            case "IsActive":
              modeActive = "IsActive";
              break;
            case "IsRoaming":
              modeActive = "IsRoaming";
              break;
            default:
              break;
          }
          const currentStatus = filteredData.find(
            (employee) => employee.UserID === selectedUserId
          )[columnToUpdate];

          EmployeeActive(mode, selectedUserIdNum, currentStatus, modeActive)
            .then((response) => {})
            .catch((err) => console.log(err));

          employee[columnToUpdate] =
            columnToUpdate === "IsActive"
              ? employee[columnToUpdate] === 1
                ? 0
                : 1
              : columnToUpdate === "IsLogin"
              ? employee[columnToUpdate] === 1
                ? 0
                : 1
              : columnToUpdate === "IsRoaming"
              ? employee[columnToUpdate] === 1
                ? 0
                : 1
              : employee[columnToUpdate];
        }
        return employee;
      });
      setFilteredData(updatedData);
    }
    setOpenConfirmation(false);
  };
  const handleCancelChange = () => {
    setOpenConfirmation(false);
  };

  const handleSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchQuery(searchValue);
    const searchedEmployees = employeeFullData.filter((employee) => {
      const firstName = employee.firstname
        ? employee.firstname.toLowerCase()
        : "";
      const lastName = employee.lastname ? employee.lastname.toLowerCase() : "";
      const fullName = `${firstName} ${lastName}`.trim(); // Combine first and last name
      const email = employee.Email ? employee.Email.toLowerCase() : "";
      const userId = employee.UserID ? employee.UserID.toString() : "";
      return (
        fullName.includes(searchValue) || // Check full name
        email.includes(searchValue) || // Check email
        userId.includes(searchValue) // Check user ID
      );
    });

    setFilteredData(searchedEmployees);
  };

  const handleClickShowPassword = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const clearSearch = () => {
    setSearchQuery(""); // Clear the search query
    setFilteredData(employeeFullData); // Reset the filtered data
  };

  return (
    <div className="employee_main">
      <Dialog
        open={openConfirmation}
        onClose={handleCancelChange}
        className="employeeResetPass_model"
      >
        <div className="Employee_model_active_div">
          <p variant="h6" className="employeeResetPass_model_ActiveTitle">
            {confirmationMessage}
          </p>
          <div
            style={{ display: "flex", justifyContent: "flex-end", gap: "15px" }}
          >
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleConfirmChange}
              className="confirmation_yes_button"
            >
              Yes
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              fullWidth
              onClick={handleCancelChange}
              className="confirmation_No_button"
            >
              No
            </Button>
          </div>
        </div>
      </Dialog>
      <Dialog 
        open={openModal}
        onClose={handleModalClose}
        className="employeeResetPass_model"
      >
        <div
          onClick={handleModalClose}
          style={{
            cursor: "pointer",
            position: "absolute",
            top: "13px", // Adjust based on your design
            right: "5px", // Adjust based on your design
          }}
        >
          <IoClose
            style={{ color: "#7367f0", fontSize: "25px" }}
          />
        </div>
        <div className="employeeResetPass_model_div">
          <p className="employeeResetPass_model_Title">Reset Password</p>
          <CustomTextField
            label="User ID"
            fullWidth
            value={passwordDetails.userId}
            onChange={(e) => handleInputChange("userId", e.target.value)}
            style={{ marginBottom: 20 }}
            error={Boolean(errors.userId)}
            helperText={errors.userId}
          />

          <CustomTextField
            label="New Password"
            type={showPassword.currentPassword ? "text" : "password"}
            fullWidth
            value={passwordDetails.currentPassword}
            onChange={(e) =>
              handleInputChange("currentPassword", e.target.value)
            }
            style={{ marginBottom: 20 }}
            error={Boolean(errors.currentPassword)}
            helperText={errors.currentPassword}
            InputProps={{
              endAdornment: (
                <Button
                  onClick={() => handleClickShowPassword("currentPassword")}
                  style={{ marginRight: "-10px" }}
                >
                  {showPassword.currentPassword ? (
                    <VisibilityOff style={{ color: "#7367f0" }} />
                  ) : (
                    <Visibility style={{ color: "#7367f0" }} />
                  )}
                </Button>
              ),
            }}
          />

          <CustomTextField
            label="Confirm Password"
            type={showPassword.confirmPassword ? "text" : "password"}
            fullWidth
            value={passwordDetails.confirmPassword}
            onChange={(e) =>
              handleInputChange("confirmPassword", e.target.value)
            }
            style={{ marginBottom: 20 }}
            error={Boolean(errors.confirmPassword)}
            helperText={errors.confirmPassword}
            InputProps={{
              endAdornment: (
                <Button
                  onClick={() => handleClickShowPassword("confirmPassword")}
                  style={{ marginRight: "-10px" }}
                >
                  {showPassword.confirmPassword ? (
                    <VisibilityOff style={{ color: "#7367f0" }} />
                  ) : (
                    <Visibility style={{ color: "#7367f0" }} />
                  )}
                </Button>
              ),
            }}
          />

          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleSave}
            className="RetestPassWord_btn"
          >
            Save
          </Button>
        </div>
      </Dialog>
      <Header otherPage={true} title="Employees" />
      <div style={{ padding: "60px 5px 5px 5px" }}>
        <div style={{ margin: "0px 5px 25px 0px" }}>
          <CustomTextField
            className="searchBox_input"
            value={searchQuery}
            onChange={handleSearch}
            placeholder="Search ..."
            InputProps={{
              endAdornment: searchQuery && (
                <IconButton onClick={clearSearch}>
                  <IoMdClose className="catelog_searchClose_icone" />
                </IconButton>
              ),
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
            }}
          >
            <CustomTextField
              select
              fullWidth
              value={filterOption}
              onChange={(e) => {
                const status = e.target.value;
                setFilterOption(status);
                handleFilter(status);
              }}
              customFontSize="0.8125rem"
              size="small"
              className="selectDropDownMain"
              variant="filled"
            >
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="IsActive">Active</MenuItem>
              <MenuItem value="IsRoaming">Roaming</MenuItem>
              <MenuItem value="IsLogin">Login</MenuItem>
              <MenuItem value="Deactive">Deactive</MenuItem>{" "}
            </CustomTextField>
          </div>

          <Button onClick={handleModalOpen} className="resetPasswordLink">
            Reset Password
          </Button>
        </div>

        <div ref={gridRef} style={{ width: "100%", backgroundColor: "white" }}>
          <DataGrid
            rows={filteredData}
            columns={columns}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            pageSizeOptions={[25, 50, 100]}
            pagination
            className="employee_datagrid"
            loading={isLoading}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 25,
                },
              },
            }}
            localeText={{ noRowsLabel: "No Data" }}
            components={{
              Toolbar: () => null,
              LoadingOverlay: () => (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  Loading...
                </div>
              ),
            }}
          />
        </div>
      </div>
      <Snackbar message="Successfully!" open={snackbarOpen} />
    </div>
  );
};

export default Employee;

// import React, { useState } from "react";
// import "./Employee.scss";
// import CustomTextField from "../../TextFiled/Index";
// import {
//   Box,
//   Button,
//   Dialog,
//   InputAdornment,
//   Modal,
//   Typography,
// } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
// import { IoIosSearch } from "react-icons/io";
// import { IoChevronBackOutline } from "react-icons/io5";
// import { useNavigate } from "react-router-dom";

// const Employee = () => {
//   const employeeData = [
//     {
//       id: 1,
//       userName: "John Doe",
//       usrCode: "JD001",
//       department: "HR",
//       active: true,
//       roming: false,
//       login: true,
//     },
//     {
//       id: 2,
//       userName: "Jane Smith",
//       usrCode: "JS002",
//       department: "IT",
//       active: false,
//       roming: false,
//       login: false,
//     },
//     {
//       id: 3,
//       userName: "Mike Johnson",
//       usrCode: "MJ003",
//       department: "Finance",
//       active: true,
//       roming: true,
//       login: true,
//     },
//     {
//       id: 4,
//       userName: "Emily Brown",
//       usrCode: "EB004",
//       department: "Sales",
//       active: false,
//       roming: false,
//       login: true,
//     },
//     {
//       id: 5,
//       userName: "Chris Lee",
//       usrCode: "CL005",
//       department: "Marketing",
//       active: true,
//       roming: false,
//       login: true,
//     },
//     {
//       id: 6,
//       userName: "Sarah Wilson",
//       usrCode: "SW006",
//       department: "IT",
//       active: false,
//       roming: false,
//       login: true,
//     },
//     {
//       id: 7,
//       userName: "Tom Adams",
//       usrCode: "TA007",
//       department: "HR",
//       active: true,
//       roming: false,
//       login: true,
//     },
//     {
//       id: 8,
//       userName: "Olivia Green",
//       usrCode: "OG008",
//       department: "Sales",
//       active: false,
//       roming: false,
//       login: true,
//     },
//     {
//       id: 9,
//       userName: "James White",
//       usrCode: "JW009",
//       department: "Finance",
//       active: true,
//       roming: false,
//       login: true,
//     },
//     {
//       id: 10,
//       userName: "Sophia Black",
//       usrCode: "SB010",
//       department: "Marketing",
//       active: false,
//       roming: false,
//       login: true,
//     },
//   ];

//   const [filteredData, setFilteredData] = useState(employeeData);
//   const [openModal, setOpenModal] = useState(false);
//   const [passwordDetails, setPasswordDetails] = useState({
//     userId: "",
//     currentPassword: "",
//     confirmPassword: "",
//   });
//   const navigate = useNavigate();

//   const handleFilter = (isActive) => {
//     const filtered = employeeData.filter(
//       (employee) => employee.active === isActive
//     );
//     setFilteredData(filtered);
//   };

//   const columns = [
//     {
//       field: "userName",
//       headerName: "Name",
//       width: 150,
//       renderCell: (params) => (
//         <div style={{ display: "flex", flexDirection: "column" }}>
//           <span style={{ fontWeight: "bold", color: "#333", display: 'flex', alignItems: 'center', height:'20px' }}>{params.row.userName}</span>
//           <span style={{ fontSize: "12px", color: "#777",display: 'flex', alignItems: 'center', height:'20px' }}>
//             {params.row.usrCode} - {params.row.department}
//           </span>
//         </div>
//       ),
//     },
//     // { field: "userName", headerName: "Name", width: 100 },
//     { field: "usrCode", headerName: "Code", width: 100 },
//     { field: "department", headerName: "Department", width: 120 },
//     {
//       field: "active",
//       headerName: "Active",
//       width: 100,
//       renderCell: (params) => (
//         <div
//           style={{
//             width: "10px",
//             height: "10px",
//             borderRadius: "50%",
//             backgroundColor: params.value
//               ? "rgb(40, 199, 111)"
//               : "rgb(244, 67, 54)",
//           }}
//         ></div>
//       ),
//     },
//     {
//       field: "login",
//       headerName: "Login",
//       width: 100,
//       renderCell: (params) => (
//         <div
//           style={{
//             width: "10px",
//             height: "10px",
//             borderRadius: "50%",
//             backgroundColor: params.value
//               ? "rgb(40, 199, 111)"
//               : "rgb(244, 67, 54)",
//           }}
//         ></div>
//       ),
//     },
//     {
//       field: "roming",
//       headerName: "Roming",
//       width: 100,
//       renderCell: (params) => (
//         <div
//           style={{
//             width: "10px",
//             height: "10px",
//             borderRadius: "50%",
//             backgroundColor: params.value
//               ? "rgb(40, 199, 111)"
//               : "rgb(244, 67, 54)",
//           }}
//         ></div>
//       ),
//     },
//   ];

//   const handleModalOpen = () => {
//     setOpenModal(true);
//   };

//   const handleModalClose = () => {
//     setOpenModal(false);
//     setPasswordDetails({
//       userId: "",
//       currentPassword: "",
//       confirmPassword: "",
//     });
//   };

//   const handleInputChange = (field, value) => {
//     setPasswordDetails((prev) => ({ ...prev, [field]: value }));
//   };

//   const handleSave = () => {
//     handleModalClose();
//   };

//   return (
//     <div>
//       <Dialog
//         open={openModal}
//         onClose={handleModalClose}
//         className="employeeResetPass_model"
//       >
//         <div className="employeeResetPass_model_div">
//           <p className="employeeResetPass_model_Title">Reset Password</p>
//           <CustomTextField
//             label="User ID"
//             fullWidth
//             value={passwordDetails.userId}
//             onChange={(e) => handleInputChange("userId", e.target.value)}
//             style={{ marginBottom: 20 }}
//           />
//           <CustomTextField
//             label="Current Password"
//             type="password"
//             fullWidth
//             value={passwordDetails.currentPassword}
//             onChange={(e) =>
//               handleInputChange("currentPassword", e.target.value)
//             }
//             style={{ marginBottom: 20 }}
//           />
//           <CustomTextField
//             label="Confirm Password"
//             type="password"
//             fullWidth
//             value={passwordDetails.confirmPassword}
//             onChange={(e) =>
//               handleInputChange("confirmPassword", e.target.value)
//             }
//             style={{ marginBottom: 20 }}
//           />
//           <Button
//             variant="contained"
//             color="primary"
//             fullWidth
//             onClick={handleSave}
//           >
//             Save
//           </Button>
//         </div>
//       </Dialog>
//       <div className="Employe_header">
//         <div>
//           <IoChevronBackOutline
//             style={{ height: "30px", width: "30px", color: "#ad9696" }}
//             onClick={() => navigate("/")}
//           />
//         </div>
//         <p
//           style={{
//             margin: "0px",
//             fontSize: "19px",
//             fontWeight: 600,
//             color: "gray",
//             marginBottom: "7px",
//           }}
//         >
//           Employee
//         </p>
//       </div>

//       <div style={{ padding: "5px" }}>
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "flex-end",
//             gap: "10px",
//             marginBottom: "10px",
//           }}
//         >
//           <Button
//             variant="outlined"
//             color="success"
//             onClick={() => handleFilter(true)}
//             style={{ display: "flex", alignItems: "center", gap: "5px" }}
//           >
//             Active
//             <div
//               className="dot"
//               style={{
//                 width: "5px",
//                 height: "5px",
//                 background: "rgb(40, 199, 111)",
//                 borderRadius: "50%",
//               }}
//             ></div>
//           </Button>
//           <Button
//             variant="outlined"
//             color="error"
//             onClick={() => handleFilter(false)}
//             style={{ display: "flex", alignItems: "center", gap: "5px" }}
//           >
//             DeActive
//             <div
//               className="Deactive"
//               style={{
//                 width: "5px",
//                 height: "5px",
//                 background: "rgb(244, 67, 54)",
//                 borderRadius: "50%",
//               }}
//             ></div>
//           </Button>
//         </div>
//         <div style={{ margin: "0px 5px 5px 0px" }}>
//           <CustomTextField
//             className="searchBox_input"
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <IoIosSearch />
//                 </InputAdornment>
//               ),
//             }}
//           />
//         </div>
//         <div style={{ height: 400, width: "100%", backgroundColor: "white" }}>
//           <DataGrid rows={filteredData} columns={columns} pageSize={5} />
//         </div>
//       </div>
//       <p onClick={handleModalOpen} className="resetPasswordLink">
//         Reset Password
//       </p>
//     </div>
//   );
// };

// export default Employee;
